import { startAppListening } from '../..';
import {
    deleteImage,
    uploadFile,
} from '../../reducers/common/thunks/imageUploadThunks';
import toast from 'react-hot-toast';
import i18n from '../../../services/i18n';

startAppListening({
    actionCreator: uploadFile.rejected,
    effect: (_, store) => {
        const error = store.getState().imageUpload.error;
        if (error) {
            toast.error(i18n.t(error));
        }
    },
});

startAppListening({
    actionCreator: deleteImage.rejected,
    effect: (_, store) => {
        const error = store.getState().imageUpload.error;
        if (error) {
            toast.error(i18n.t(error));
        }
    },
});
